import { useObjectTypeDefinitions as useObjectTypesFromContext } from '../context/ObjectTypeDefinitionsContext';

// TODO: Remove this file and import from the context instead
/**
 * Retrieve an ImmutableMap that stores Object type definition
 */
export const useObjectTypeDefinitions = useObjectTypesFromContext;